import dayjs from "dayjs";
import { ensureLocaleInfo , getZoneBasedOnLocaleInfo } from "../dateUtils";

export function getPastDueDays(input, key = "dueDate") {
  try {
    const value = typeof input === "object" && input !== null ? input[key] : input;
    if (!value || value === "-") { return "-"; }
    
    const orgTimeZone = getZoneBasedOnLocaleInfo();

    const dueDate = dayjs.utc(value).tz(orgTimeZone).startOf("day");
    const today = dayjs().tz(orgTimeZone).startOf("day");    
    const diff = today.diff(dueDate, "day");
    // if (diff < 0) {
    //   return diff;
    // }
    // return diff + 1;
    return diff;
  } catch (error) {
    console.error("Error in getPastDueDays:", error);
    return "-";
  }
}